export const EVENTS = {
  SHARED: {
    RELOAD_APP_TO_HOME: 'shared.RELOAD_APP_TO_HOME',
    RELOAD_APP: 'shared.RELOAD_APP',
    LAUNCHED_USSD: 'shared.LAUNCHED_USSD',
  }
};
